import { z } from 'zod';

/** The knowledge index a Spec run carries: page refs and descriptions, and folder counts past the page cap. */
export const SPEC_KNOWLEDGE_INDEX_LIMITS = { pages: 150, folders: 100 } as const;

export const SpecKnowledgeIndexSchema = z.object({
  pages: z
    .array(z.object({ ref: z.string().max(1_000), description: z.string().max(600).nullable() }))
    .max(SPEC_KNOWLEDGE_INDEX_LIMITS.pages),
  total: z.number().int().nonnegative(),
  /** Present only when more pages exist than are listed. */
  folders: z
    .array(z.object({ path: z.string().max(1_000), pages: z.number().int().nonnegative() }))
    .max(SPEC_KNOWLEDGE_INDEX_LIMITS.folders)
    .optional(),
});

export type SpecKnowledgeIndex = z.infer<typeof SpecKnowledgeIndexSchema>;

/** What a run without an index (an older API, an index read that failed) carries. */
export const EMPTY_SPEC_KNOWLEDGE_INDEX: SpecKnowledgeIndex = { pages: [], total: 0 };
